import type { AxiosError } from 'axios';
import { createQuery } from 'react-query-kit';

import { client } from '../common';

export type JooserAppointmentType = {
  id: number;
  duration: number;
  price: string;
};

type Variables = { id: number };
type Response = JooserAppointmentType[];

export const useJooserAppointmentTypes = createQuery<
  Response,
  Variables,
  AxiosError
>({
  queryKey: ['jooser/appointment-types'],
  fetcher: ({ id }) => {
    return client
      .get(`v2/reservations/${id}/jooser/appointment-types`)
      .then((response) => {
        return response.data.data;
      });
  },
});
